const galleryId = 112;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1681720222.jpg","sh_1684552525.jpg","sh_1542434426.jpg","sh_1751363957.jpg","sh_1751363948.jpg","sh_1542434429.jpg","sh_1182732049.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Palatal expansion'));

export default items;
